// The current solution only works when a view has at most one element with data-trigger="condition".
// To use more than one, this must be refactored.

class Conditional {
    private element: JQuery;
    private form: JQuery;
    private fields: JQuery;

    constructor(element: HTMLElement) {
        this.element = $(element);
        this.form = this.element.closest('form');
        this.fields = this.form.find('[data-condition]');

        this.init();
    }

    private init(): void {
        this.showHideFields();
        this.element.on('change.conditional', this.showHideFields.bind(this));
    }

    private showHideFields(): void {
        const activeCondition: string = this.element.val() as string;

        this.fields.each((index, element) => {
            const field: JQuery = $(element);
            const condition: string = `${field.data('condition')}`;
            const isRequired: string = field.data('required') ?? false;
            const closestFormGroup: JQuery = field.closest('.form-group');

            if (condition.includes(activeCondition)) {
                closestFormGroup.removeClass('hidden');

                if (isRequired) {
                    field.prop('required', true);
                }
            } else {
                closestFormGroup.addClass('hidden');
                field.prop('required', false);
            }
        });
    }
}

$(() => {
    const element: HTMLElement = document.querySelector('[data-trigger="condition"]');
    new Conditional(element);
});
